import Hero from "@/components/ui/Hero";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function PrivacyPolicy() {
    useDocumentTitle(
        "Privacy Policy · A1 Screening · Naples, FL",
        "A1 Screening privacy policy. We use your information only to follow up on your estimate. We do not sell customer information."
    );
    return (
        <>
            <Hero eyebrow="Legal" title="Privacy Policy" />
            <section className="a1-section">
                <div className="a1-container max-w-3xl space-y-4 text-[var(--color-text)]">
                    <p>
                        <strong>Plain-English summary:</strong> A1 Screening uses the contact details you share to follow up on your estimate or service request. We do not sell customer information and we do not share it with third-party marketers.
                    </p>

                    <h3>Who we are</h3>
                    <p>
                        A1 Screening · Naples, FL · serving Southwest Florida · phone <a href="tel:+12394347306">239-434-7306</a> · email <a href="mailto:info@a1screening247.com">info@a1screening247.com</a> · hours 7:00 AM – 5:00 PM.
                    </p>

                    <h3>What we collect</h3>
                    <p>
                        A1 Screening may collect contact details you submit through our forms — including name, phone number, email, city or service address, service details, photos you upload, and any notes you share with us.
                    </p>

                    <h3>How we use it</h3>
                    <p>
                        A1 Screening may contact customers by phone, text, or email about service requests submitted through our forms. We use your information to prepare an estimate, follow up on your request, and schedule work. Customer information is not sold and is not shared with third-party marketers.
                    </p>

                    <h3>SMS / text-message consent</h3>
                    <p>
                        By submitting a form on this site, you consent to receive service-related text messages from A1 Screening about your estimate or service request. Message and data rates may apply. Message frequency varies. SMS opt-out is available at any time — reply <strong>STOP</strong> to any text message we send and we'll stop texting you. Reply <strong>HELP</strong> for help, or contact us directly at <a href="tel:+12394347306">239-434-7306</a> or <a href="mailto:info@a1screening247.com">info@a1screening247.com</a>.
                    </p>
                    <p>
                        A1 Screening does not send marketing or promotional SMS. Texts you receive from us are service-related / customer-care communications (e.g. appointment confirmations, follow-ups on your estimate, and answers to questions you sent us).
                    </p>

                    <h3>Photo permissions</h3>
                    <p>
                        Photos you upload are used internally to prepare your estimate. We never publish customer photos on our public gallery without written permission.
                    </p>

                    <h3>Contact</h3>
                    <p>
                        Questions about this policy? Email <a href="mailto:info@a1screening247.com">info@a1screening247.com</a> or call <a href="tel:+12394347306">239-434-7306</a>.
                    </p>
                </div>
            </section>
        </>
    );
}
